import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {getDispensary, updateDispensary} from './actions';
import {bindActionCreators} from "redux";
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateDispensaryForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.dispensaryId !== this.props.match.params.dispensaryId) {
      this._load();
    }
  }

  _load = () => {
    const {dispensaryId} = decodeParams(this.props.match.params);
    if (dispensaryId) {
      this.props.getDispensary({dispensaryId});
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {dispensaryId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.updateDispensary({...values, dispensaryId})
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  };

  render() {
    const {dispensary, form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    const {name, address, phoneNumber} = dispensary;
    const [addressStreet, addressCity, addressState, addressCountry, addressPostalCode] = (address || '').split(', ');
    return (
      <Card title="Update Dispensary">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Street Address"
          >
            {getFieldDecorator('addressStreet', {initialValue: addressStreet})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="City"
          >
            {getFieldDecorator('addressCity', {initialValue: addressCity})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="State/Province"
          >
            {getFieldDecorator('addressState', {initialValue: addressState})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Country"
          >
            {getFieldDecorator('addressCountry', {initialValue: addressCountry})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Postal Code"
          >
            {getFieldDecorator('addressPostalCode', {initialValue: addressPostalCode})(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Phone"
          >
            {getFieldDecorator('phoneNumber', {
              initialValue: phoneNumber,
              rules: [
                {pattern: /^\d{3}\s\d{3}-\d{4}$/, message: 'phone number should be in the format: 555 555-5555'}
              ]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Dispensary
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateDispensaryForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  updateDispensary: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  getDispensary: PropTypes.func.isRequired,
  dispensary: PropTypes.object.isRequired,
};

const UpdateDispensaryPage = Form.create()(UpdateDispensaryForm);

const mapStateToProps = state => ({
  loading: state.dispensary.dispensaryLoading || state.dispensary.updatingDispensary,
  dispensary: state.dispensary.dispensary || {}
});

const mapDispatchToProps = dispatch => ({
  getDispensary: payload => (dispatch(getDispensary(payload))),
  updateDispensary: bindActionCreators(updateDispensary, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateDispensaryPage);



// WEBPACK FOOTER //
// ./src/Dispensary/UpdateDispensaryPage.js